import { getScrollY } from '../mda-gsap/_shared';

export default function setHeaderMenu() {
    const headerMain = document.querySelector('[data-header]');
    const headerWrapper = document.querySelector('[data-header-wrapper]');
    const logo = document.querySelector('[data-header-logo]');
    const logoImg = document.querySelector('[data-header-logo] img');
    const menu = document.querySelector('[data-header-menu]');
    if (!menu) return;

    const toggle = document.querySelector('[data-header-toggle]');
    const back = document.querySelector('[data-header-menu-back]');
    const title = document.querySelector('[data-header-current-menu]');
    const items = menu.querySelectorAll('.menu-item-has-children');

    const investmentsTrigger = document.querySelector(
        '[data-header-menu-investments]'
    );
    const investmentsDropdown = document.querySelector(
        '[data-header-menu-investments-dropdown]'
    );

    const mobileSearch = document.querySelector('[data-header-mobile-search]');
    const mobileLogin = document.querySelector('[data-header-mobile-login]');
    const mobileSocials = document.querySelector(
        '[data-header-mobile-socials]'
    );
    const closeBtn = document.querySelector('[data-header-menu-close]');

    const isMobile = () => window.matchMedia('(max-width: 1279px)').matches;

    const COMPACT_ENTER_Y = 64;
    const COMPACT_EXIT_Y = 32;
    const HEADER_DROPDOWN_FADE_MS = 400;
    const HEADER_HOVER_GRACE_MS = 100;

    let stack = ['Menu'];
    let investmentsHoverCloseTimer = null;
    const menuItemHoverCloseTimers = new Map();
    let isCompactHeader = false;
    let scrollRaf = null;

    function cancelInvestmentsHoverClose() {
        if (investmentsHoverCloseTimer !== null) {
            clearTimeout(investmentsHoverCloseTimer);
            investmentsHoverCloseTimer = null;
        }
    }

    function cancelMenuItemHoverClose(item) {
        const timer = menuItemHoverCloseTimers.get(item);
        if (timer !== undefined) {
            clearTimeout(timer);
            menuItemHoverCloseTimers.delete(item);
        }
    }

    function cancelAllMenuItemHoverClose() {
        menuItemHoverCloseTimers.forEach(timer => {
            clearTimeout(timer);
        });
        menuItemHoverCloseTimers.clear();
    }

    function scheduleMenuItemHoverClose(item) {
        cancelMenuItemHoverClose(item);
        const timer = window.setTimeout(() => {
            menuItemHoverCloseTimers.delete(item);
            item.classList.remove('is-active');
        }, HEADER_HOVER_GRACE_MS);
        menuItemHoverCloseTimers.set(item, timer);
    }

    function openMenuItemHover(item) {
        cancelAllMenuItemHoverClose();
        items.forEach(i => {
            if (i !== item) {
                i.classList.remove('is-active');
            }
        });
        item.classList.add('is-active');
    }

    function clearDesktopHoverState() {
        cancelInvestmentsHoverClose();
        cancelAllMenuItemHoverClose();
        if (isMobile()) {
            items.forEach(i => i.classList.remove('is-active'));
        }
    }

    function handleScroll() {
        if (!headerWrapper) return;

        const y = getScrollY();

        if (isMobile()) {
            if (y > 0) {
                headerMain.classList.add('-scrolled');
            } else {
                headerMain.classList.remove('-scrolled');
            }

            return;
        }

        const wasCompactHeader = isCompactHeader;

        if (!isCompactHeader && y >= COMPACT_ENTER_Y) {
            isCompactHeader = true;
        } else if (isCompactHeader && y <= COMPACT_EXIT_Y) {
            isCompactHeader = false;
        }

        if (isCompactHeader) {
            headerMain.classList.add('-scrolled');
        } else {
            headerMain.classList.remove('-scrolled');
        }

        if (wasCompactHeader !== isCompactHeader) {
            window.dispatchEvent(new CustomEvent('mda-header-layout-change'));
        }

        if (isCompactHeader) {
            headerWrapper.classList.add('xl:!py-[12px]');

            if (logo) {
                logo.classList.remove('2xl:min-w-[300px]');
                logo.classList.add('2xl:min-w-[200px]');
            }

            if (logoImg) {
                logoImg.classList.remove('2xl:max-w-[300px]');
                logoImg.classList.add('2xl:max-w-[200px]');
            }
        } else {
            headerWrapper.classList.remove('xl:!py-[12px]');

            if (logo) {
                logo.classList.remove('2xl:min-w-[200px]');
                logo.classList.add('2xl:min-w-[300px]');
            }

            if (logoImg) {
                logoImg.classList.remove('2xl:max-w-[200px]');
                logoImg.classList.add('2xl:max-w-[300px]');
            }
        }
    }

    function scheduleScroll() {
        if (scrollRaf !== null) return;
        scrollRaf = window.requestAnimationFrame(() => {
            scrollRaf = null;
            handleScroll();
        });
    }

    window.addEventListener('scroll', scheduleScroll, { passive: true });
    handleScroll();

    function updateTitle() {
        if (title) title.textContent = stack[stack.length - 1];
        updateBackVisibility();
    }

    // HELPERS
    const hideMobileExtras = () => {
        if (mobileSearch) mobileSearch.style.display = 'none';
        if (mobileLogin) mobileLogin.style.display = 'none';
        if (mobileSocials) mobileSocials.style.display = 'none';
    };

    const showMobileExtras = () => {
        if (mobileSearch) mobileSearch.style.display = '';
        if (mobileLogin) mobileLogin.style.display = '';
        if (mobileSocials) mobileSocials.style.display = '';
    };

    const updateBackVisibility = () => {
        if (!back) return;

        if (isMobile() && stack.length > 1) {
            back.style.display = 'flex';
        } else {
            back.style.display = 'none';
        }
    };

    function dismissInvestmentsPanel() {
        cancelInvestmentsHoverClose();
        if (investmentsTrigger) {
            investmentsTrigger.classList.remove('is-active');
        }
        if (investmentsDropdown) {
            investmentsDropdown.classList.remove('is-active');
        }
        document.body.classList.remove('is-investments-open');
    }

    const hideInvestments = () => {
        dismissInvestmentsPanel();
        if (investmentsTrigger && isMobile()) {
            investmentsTrigger.style.display = 'none';
        }
    };

    const showInvestments = () => {
        if (investmentsTrigger) {
            investmentsTrigger.style.display = '';
        }
    };

    // =========================
    // OPEN / CLOSE MENU
    // =========================
    if (toggle) {
        toggle.addEventListener('click', () => {
            menu.classList.toggle('is-open');
            document.body.classList.toggle('overflow-hidden');

            if (!menu.classList.contains('is-open')) {
                resetMenu();
            }
        });
    }

    document.addEventListener('click', e => {
        const clickedInsideMenu = menu.contains(e.target);
        const clickedToggle = toggle && toggle.contains(e.target);

        const clickedInvestmentsTrigger =
            investmentsTrigger && investmentsTrigger.contains(e.target);
        const clickedInvestmentsDropdown =
            investmentsDropdown && investmentsDropdown.contains(e.target);

        // CLOSE MAIN MENU
        if (!clickedInsideMenu && !clickedToggle) {
            menu.classList.remove('is-open');
            document.body.classList.remove('overflow-hidden');
            resetMenu();
        }

        // CLOSE INVESTMENTS IF CLICK OUTSIDE
        if (investmentsTrigger && investmentsDropdown) {
            const clickedInsideInvestments =
                clickedInvestmentsTrigger || clickedInvestmentsDropdown;

            if (!clickedInsideInvestments) {
                dismissInvestmentsPanel();
            }
        }
    });

    // =========================
    // SUBMENU CLICK
    // =========================
    items.forEach(item => {
        const link = item.querySelector(':scope > a');
        if (!link) return;

        link.addEventListener('click', e => {
            const label = link.textContent.trim();
            const isChildLink = !!link.closest('.sub-menu');

            if (!isMobile()) {
                if (isChildLink) {
                    dismissInvestmentsPanel();
                }
                return;
            }

            e.preventDefault();

            items.forEach(i => i.classList.remove('is-active'));
            item.classList.add('is-active');
            menu.classList.add('is-drilled');
            stack = ['Menu', label];

            if (investmentsTrigger) {
                investmentsTrigger.style.display = 'none';
            }

            hideMobileExtras();

            updateTitle();

            if (isChildLink) {
                hideInvestments();
            }
        });
    });

    if (back) {
        if (back) {
            back.addEventListener('click', () => {
                if (!isMobile()) return;

                const active = menu.querySelector(
                    '.menu-item-has-children.is-active'
                );

                if (active) {
                    active.classList.remove('is-active');
                }

                if (investmentsTrigger) {
                    investmentsTrigger.style.display = 'block';
                }

                menu.classList.remove('is-drilled');

                showMobileExtras(); // 👈 NOWE

                stack = ['Menu'];
                updateTitle();
            });
        }
    }

    if (closeBtn) {
        closeBtn.addEventListener('click', () => {
            menu.classList.remove('is-open');
            document.body.classList.remove('overflow-hidden');

            resetMenu();
        });
    }

    // =========================
    // DESKTOP: MENU ITEM HOVER (grace for gap, fade via CSS)
    // =========================
    items.forEach(item => {
        const subMenu = item.querySelector(':scope > .sub-menu');
        const hoverTargets = subMenu ? [item, subMenu] : [item];

        hoverTargets.forEach(el => {
            el.addEventListener('mouseenter', () => {
                if (!isMobile()) {
                    openMenuItemHover(item);
                }
            });
            el.addEventListener('mouseleave', () => {
                if (!isMobile()) {
                    scheduleMenuItemHoverClose(item);
                }
            });
        });
    });

    // =========================
    // INVESTMENTS TOGGLE
    // =========================
    if (investmentsTrigger && investmentsDropdown) {
        function scheduleInvestmentsHoverClose() {
            cancelInvestmentsHoverClose();
            investmentsHoverCloseTimer = window.setTimeout(() => {
                investmentsHoverCloseTimer = null;
                investmentsTrigger.classList.remove('is-active');
                document.body.classList.remove('is-investments-open');
            }, HEADER_HOVER_GRACE_MS);
        }

        function openInvestmentsHover() {
            cancelInvestmentsHoverClose();
            investmentsTrigger.classList.add('is-active');
            document.body.classList.add('is-investments-open');
            stack = ['Menu', 'Mieszkania'];
            updateTitle();
        }

        investmentsTrigger.addEventListener('mouseenter', () => {
            if (!isMobile()) {
                openInvestmentsHover();
            }
        });
        investmentsDropdown.addEventListener('mouseenter', () => {
            if (!isMobile()) {
                openInvestmentsHover();
            }
        });
        investmentsTrigger.addEventListener('mouseleave', () => {
            if (!isMobile()) {
                scheduleInvestmentsHoverClose();
            }
        });
        investmentsDropdown.addEventListener('mouseleave', () => {
            if (!isMobile()) {
                scheduleInvestmentsHoverClose();
            }
        });

        investmentsTrigger.addEventListener('click', e => {
            if (!isMobile()) {
                return;
            }

            e.preventDefault();
            const isOpen = investmentsTrigger.classList.contains('is-active');

            menu.querySelectorAll('.menu-item-has-children.is-active').forEach(
                i => i.classList.remove('is-active')
            );

            menu.classList.remove('is-drilled');

            if (isOpen) {
                investmentsTrigger.classList.remove('is-active');
                document.body.classList.remove('is-investments-open');
            } else {
                investmentsTrigger.classList.add('is-active');
                document.body.classList.add('is-investments-open');
            }

            stack = ['Menu', 'Mieszkania'];
            updateTitle();

            hideMobileExtras();
        });
    }

    window
        .matchMedia('(max-width: 1279px)')
        .addEventListener('change', clearDesktopHoverState);

    // =========================
    // RESET
    // =========================
    function resetMenu() {
        cancelInvestmentsHoverClose();
        cancelAllMenuItemHoverClose();

        menu.classList.remove('is-drilled');
        menu.querySelectorAll('.is-active').forEach(i =>
            i.classList.remove('is-active')
        );

        if (investmentsTrigger) {
            investmentsTrigger.classList.remove('is-active');
        }

        document.body.classList.remove('is-investments-open');

        showInvestments();

        if (investmentsTrigger) {
            investmentsTrigger.style.display = 'block';
        }

        stack = ['Menu'];
        updateTitle();
        showMobileExtras();
    }

    updateTitle();
}
